import React, { useEffect, useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './styles/App.css';
import ContactForm from './components/ContactForm';

function App(): React.JSX.Element {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '';
  const isDebug = process.env.NODE_ENV === 'development';
  const [isInIframe, setIsInIframe] = useState(false);

  // Check if the app is running inside an iframe
  useEffect(() => {
    try {
      setIsInIframe(window.self !== window.top);
    } catch (e) {
      // If we can't access window.top due to cross-origin restrictions,
      // we're definitely in an iframe
      setIsInIframe(true);
    }
  }, []);

  // Validate environment configuration on app startup
  useEffect(() => {
    if (!recaptchaSiteKey && isDebug) {
      alert('Missing required environment variable:\nREACT_APP_RECAPTCHA_SITE_KEY\n\nPlease check ENVIRONMENT_SETUP.md for instructions.');
    }
  }, [recaptchaSiteKey, isDebug]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      <div className={`App ${isInIframe ? 'iframe-mode' : ''}`}>
        <div className="App-container">
          <main>
            <ContactForm />
          </main>
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;
